import module from 'finanzas/module.js'

module.config(($stateProvider) => {
  $stateProvider
    .state('finances', {
      url: '/finanzas',
      abstract: true,
      data: {
        title: 'Finanzas',
      },
      resolve: {
        Catalogs: ($catalogos) => $catalogos.$fetch(),
      },
      template: '<ui-view></ui-view>',
    })
})



// WEBPACK FOOTER //
// ./src/finanzas/routes/finances.js